import { SidebarCustomComponents } from '@features/sidebar';

export const MINI_CART_COMPONENT_NAME = SidebarCustomComponents.MINI_CART;
